import React, { Component } from "react";
import "./style.css";
class InfoModal extends Component {
  render() {
    const { visible, close, info } = this.props;
    return (
      <div
        style={visible === true ? { display: "block" } : { display: "none" }}
        className="info_modal_box"
      >
        <div className="info_modal_inline_box">
          <div onClick={() => close()} className="info_modal_close">
            <img alt="" src={require("../../images/user/close.png")}></img>
          </div>
          <div
            className="info_modal_content"
            dangerouslySetInnerHTML={{ __html: info }}
          ></div>
        </div>
      </div>
    );
  }
}

export default InfoModal;



// WEBPACK FOOTER //
// ./src/components/InfoModal/index.js